import Select from "../../../../../components/Select";
import GenericInputDate from "../../../../../components/GenericInputDate";
import styles from "../GrantReport.module.css";
import { useEffect, useState } from "react";
import { getGrantList } from "../../../../../services/outorga";

export default function GrantReportFilters({ filters, onChange }) {
    const [grantList, setGrantList] = useState([]);

    useEffect(() => {
        handleGetGrantList()
    }, [])

    const handleGetGrantList = async () => {
        const data = await getGrantList({
            lineCount: 999,
        });

        const grants = data.grantList.map(item => ({
            value: item.id,
            label: item.nome
        }));

        setGrantList(grants);
    };

    const handleChange = (field, value) => {
        onChange(prev => ({
            ...prev,
            [field]: value
        }));
    };

    return (
        <details open className="custom-summary">
            <summary>Filtros</summary>
            <div className={`hdv-form-default ${styles.reportFiltersForm}`}>
                <div style={{ display: 'flex' }}>
                    <div className="col-md-6">
                        <label>Período</label>
                        <GenericInputDate onChange={(value) => handleChange("period", value)} />
                    </div>

                    <div className="col-md-6">
                        <label>Outorgas</label>
                        <Select
                            options={grantList}
                            value={filters?.grants}
                            onChange={(value) => handleChange("grants", value)}
                            placeholder={'Todos'}
                            isMulti
                            ellipsisMulti
                        />
                    </div>
                </div>
                <div className="col-md-3">
                    <label className="required" >
                        <input
                            type="checkbox"
                            className="checkbox"
                            checked={filters?.onlyViolations}
                            onChange={(value) => handleChange("onlyViolations", value.target.checked)}
                        />&nbsp;
                        Somente Violações
                    </label>
                </div>
            </div>
        </details>
    );
}